module.exports = __webpack_public_path__ + "static/cinect-f9d998189c3269b6d67ff56584d4f787.png";